export default __webpack_public_path__ + "static/media/favicon_adiacom.6766f592.ico";